import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  baseUrl = environment.baseUrl;

  country_added_form: FormGroup = new FormGroup({
    id: new FormControl(null),
    sort_name: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
  });

  // state_added_form: FormGroup = new FormGroup({
  //   id: new FormControl(null),
  //   name: new FormControl('', [Validators.required]),
  //   country_id: new FormControl('', [Validators.required]),
  // });

  // city_added_form: FormGroup = new FormGroup({
  //   id: new FormControl(null),
  //   name: new FormControl('', [Validators.required]),
  //   state_id: new FormControl('', [Validators.required]),
  // });

  constructor(private http:HttpClient,) { }

  get_country_list() {
    return this.http.get(this.baseUrl + '/get_country_list');  
  }

  
  get_states(country_id) {
    return this.http.get(this.baseUrl + '/get_state_list/' + country_id);  
  }

  get_cities(state_id) {
    return this.http.get(this.baseUrl + '/get_city_list/' + state_id);  
  }

  insert_country_details(formData: any)
  { 
    return this.http.post(this.baseUrl + '/insert_country_details',{
      sortname : formData.sort_name,
      name : formData.name, 
    });
  }



}
